import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterMappedField'
})
export class FilterMappedFieldPipe implements PipeTransform {
  transform(value: any): string {
    if (value === null || value === undefined || value === '') {
      return value;
    }

    // Convert to string to handle both numbers and strings
    const stringValue = value.toString();

    // Remove the first part before underscore if it exists
    let processedValue = stringValue;
    if (stringValue.includes('_')) {
      const parts = stringValue.split('_');
      if (parts.length > 1) {
        processedValue = parts.slice(1).join('_');
      }
    }

    // Replace all digits with hash symbols
    return processedValue.replace(/\d/g, '#');
  }
}
